/**
 * Vault casement APP v1.0
 * @summary A VaultEngine app to handle the design for casement windows*
 * @since 23.08.2016
 *
 */
global.engine = {
    /**
     * Initialize a vue instance
     * Do any bootstrap work and initalize any events
     */

    created() {
        this.load((vue) => {
            vue.changeEvent('casement_style_id', (val) => {
                var opt = vue.selected_opt('casement_style_id');
                vue.set_val('right_mullion', opt.DefaultRightMul);
                vue.set_val('left_mullion', opt.DefaultLeftMul);
            });
        });
    },

    computed: {
        transom_min() {
            return this.master_setting('casement_style_id', 'min_transom_drop');
        },

        transom_max: {
            get: function () {
                return this.product_options.overall_height;
            },
            cache: false
        }
    },

    methods: {
        available_casement_width() {
            var left = parseInt(this.lookup_option('addon', 'left_addon_id').thickness);
            var right = parseInt(this.lookup_option('addon', 'right_addon_id').thickness);
            return parseInt(this.val('overall_width')) - (left + right);
        },


        get_traversed_addons(addon_type) {
            if (addon_type == 'right_addon_id')
                return this.selected_opt('left_addon_id');
            else if (addon_type == 'left_addon_id')
                return this.selected_opt('right_addon_id');
            else if (addon_type == 'top_addon_id')
                return this.selected_opt('bottom_addon_id');
            else
                return this.selected_opt('top_addon_id');
        },

        overall_width() {
            var left = parseInt(this.lookup_option('addon', 'left_addon_id').thickness);
            var right = parseInt(this.lookup_option('addon', 'right_addon_id').thickness);
            return parseInt(parseInt(this.val('overall_width')) + parseInt(left) + parseInt(right));
        },

        get_associative_addons() {

        },

        can_be_satisfied_by_addons(length, hole_length, unit) {
            var space_to_satisfy = hole_length - length; // 50mm
        },

        window_width_valid(min_width, max_width) {
            return true;
        },

        avail_with_addons(hole_length, product_max_length, available_addons) {
            // Doesn't need add-ons.

            if (product_max_length >= hole_length)
                return true;

            if(!this.option_enabled('left_addon_id'))
                return false;

            // try to fit with single add-on first.
            for (var addon_index in available_addons) {
                let addon_x1 = parseInt(parseInt(available_addons[addon_index]) + parseInt(product_max_length));
                let addon_x2 = parseInt(parseInt((available_addons[addon_index] * 2)) + parseInt(product_max_length));
                if (addon_x1 >= hole_length || addon_x2 >= hole_length) {
                    return true;
                }
            }
            return false;
        }
    }
}
require('./designer.js');